export const ROUTE_PATHS = {

    // General Routes
    HOME: '/',
    PORTFOLIO: '/portfolio',

    // Project Routes
    PROJECTS: '/projects',
    PROJECT_BARCODE_SCANNER: '/projects/barcode-scanner',
    PROJECT_TRIVIA_BATTLE: '/projects/trivia-battle-arena',

    // ADMIN
    ADMIN_DASHBOARD: '/admin',
    ADMIN_PROJECT_EDIT: '/admin/project-management/edit',
    ADMIN_PROJECT_CREATE: '/admin/project-management/create',
    ADMIN_PORTFOLIO_MANAGEMENT: '/admin/portfolio-management',
    ADMIN_PROJECT_MANAGEMENT: '/admin/project-management',
    ADMIN_TECHNOLOGY_MANAGEMENT: '/admin/tech-management',
    ADMIN_TECHNOLOGY_EDIT: '/admin/tech-management/edit',
    ADMIN_TECHNOLOGY_CREATE: '/admin/tech-management/create',
} as const;